import { Link } from "react-router-dom";
import Header from "./Header";

export default function PrivacyPolicy() {
    return (
    <div className="min-h-screen bg-[#0D1117] text-[#E6EDF3] px-6 sm:px-10 lg:px-20 py-16 pt-32">
        <Header />
        <div className="max-w-4xl mx-auto bg-[#161B22] border border-[#21262D] rounded-2xl p-8 shadow-[0_0_30px_rgba(59,130,246,0.15)]">

        <h1 className="text-3xl sm:text-4xl font-bold mb-6">
            <span className="bg-gradient-to-r from-[#06B6D4] to-[#3B82F6] text-transparent bg-clip-text">
            Privacy Policy
            </span>
        </h1>

        <div className="space-y-6 text-[#9BA6B3] leading-relaxed">

            <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Personal Data</h2>
            <p>
                BoostMyHook collects and processes personal data only for providing
                access to the platform and improving services.
            </p>
            </section>

            <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Video Processing</h2>
            <p>
                Uploaded videos are processed securely using OpenAI and automatically deleted
                after analysis. We do <strong className="text-[#E6EDF3]">not store</strong> your content permanently.
            </p>
            </section>

            <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Authentication & Cookies</h2>
            <p>
                Only essential cookies are used (authentication tokens).
                No advertising or tracking cookies without consent.
            </p>
            </section>

            <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">Payments</h2>
            <p>
                Payments are securely processed through Stripe. No banking
                information is stored by BoostMyHook.
            </p>
            </section>

            <section>
            <h2 className="text-xl text-[#E6EDF3] font-semibold mb-2">User Rights — GDPR</h2>
            <ul className="list-disc ml-5 space-y-1">
                <li>Access your data</li>
                <li>Request correction or deletion</li>
                <li>Withdraw consent</li>
            </ul>
            <p className="mt-3">
                Request support:{" "}
                <a href="mailto:hugosenee.pro@gmail.com" className="text-[#3B82F6]">
                hugosenee.pro@gmail.com
                </a>
            </p>
            </section>

            <p className="text-xs text-[#6E7681] mt-8">
            Last update: November 4th, 2025
            </p>
        </div>

        <div className="mt-8">
            <Link to="/legal/mentions" className="text-[#8B949E] hover:text-[#3B82F6]">
            ← Legal Mentions
            </Link>
        </div>

        </div>
    </div>
    );
}
